import {
    Paper,
    Typography,
    Divider,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from "@mui/material";

import StorefrontRoundedIcon from "@mui/icons-material/StorefrontRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import PaletteRoundedIcon from "@mui/icons-material/PaletteRounded";
import ShoppingCartRoundedIcon from "@mui/icons-material/ShoppingCartRounded";
import GroupRoundedIcon from "@mui/icons-material/GroupRounded";
import BackupRoundedIcon from "@mui/icons-material/BackupRounded";
import PrintIcon from '@mui/icons-material/Print';

export default function SettingsSidebar({ selectedMenu, setSelectedMenu, }) {

    const menuItems = [
        {
            key: "store",
            label: "General Settings",
            icon: <StorefrontRoundedIcon />,
        },
        {
            key: "users",
            label: "User Roles",
            icon: <GroupRoundedIcon />,
        },
        {
            key: "printer",
            label: "Printer Settings",
            icon: <PrintIcon />,
        },
        {
            key: "backup",
            label: "Backup System",
            icon: <BackupRoundedIcon />,
        },

        // {
        //     key: "receipt",
        //     label: "Receipt Settings",
        //     icon: <ReceiptLongRoundedIcon />,
        // },
        // {
        //     key: "appearance",
        //     label: "Appearance",
        //     icon: <PaletteRoundedIcon />,
        // },
        // {
        //     key: "orders",
        //     label: "Order Settings",
        //     icon: <ShoppingCartRoundedIcon />,
        // },
        
        
    ];

    return (
        <Paper
            elevation={0}
            sx={{
                width: { xs: "100%", md: 280 },
                borderRadius: 1.2,
                border: "1px solid #e5e7eb",
                p: 1.5,
                height: "fit-content",
            }}
        >
            <Typography
                sx={{
                    px: 1,
                    pb: 1,
                    fontWeight: 700,
                    fontSize: 14,
                    color: "#777",
                }}
            >
                SETTINGS MENU
            </Typography>

            <Divider sx={{ mb: 1.5 }} />

            <List sx={{ p: 0 }}>
                {menuItems.map((item) => {
                    const active =
                        selectedMenu === item.key;

                    return (
                        <ListItemButton
                            key={item.key}
                            onClick={() =>
                                setSelectedMenu(item.key)
                            }
                            sx={{
                                borderRadius: 1,
                                mb: 1,
                                py: 1.2,

                                backgroundColor: active
                                    ? "#1976d2"
                                    : "transparent",

                                color: active
                                    ? "#fff"
                                    : "#333",

                                "&:hover": {
                                    backgroundColor: active
                                        ? "#145fab"
                                        : "#f5f5f5",
                                },
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    color: active
                                        ? "#fff"
                                        : "#666",
                                    minWidth: 40,
                                }}
                            >
                                {item.icon}
                            </ListItemIcon>

                            <ListItemText
                                primary={item.label}
                                primaryTypographyProps={{
                                    fontSize: 14,
                                    fontWeight: 600,
                                }}
                            />
                        </ListItemButton>
                    );
                })}
            </List>
        </Paper>
    );
}